<template>
  <el-link type="primary" @click="handleClick(customer.customer_id)" v-if="customer.customer_id">
    {{ customer.customer_name || '' }}
  </el-link>
</template>
<script>
export default {
  name: 'CustomerDetailLink',
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick: function (id) {
      const {href} = this.$router.resolve({
        name: `detailCustom`,
        query: {id}
      });
      window.open(href, "_blank");
    }
  }
}
</script>

<style scoped>

</style>
